import { render, staticRenderFns } from "./RiseupGoalSectionMenu.vue?vue&type=template&id=3e5d29c3&scoped=true&"
import script from "./RiseupGoalSectionMenu.vue?vue&type=script&lang=js&"
export * from "./RiseupGoalSectionMenu.vue?vue&type=script&lang=js&"
import style0 from "./RiseupGoalSectionMenu.vue?vue&type=style&index=0&id=3e5d29c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d29c3",
  null
  
)

export default component.exports